import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FILE_UPLOADER} from "../../../../../componentes/file-uploader/file-uploader.component";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-obito',
  templateUrl: './obito.component.html',
  styleUrls: ['./obito.component.css']
})
export class ObitoComponent implements OnInit {

  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader: any;
  @Input() formGroup!: FormGroup;
  @Input() formSubmitted = false;
  @Input() readonly!: boolean;
  @Input() arquivosSalvos!: any[];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {}

  get arquivoControl(): FormArray {
    return this.formGroup.get('arquivo') as FormArray;
  }

  onArquivosChange(arquivos: any[]) {
    this.arquivoControl.clear();

    arquivos.forEach(arq => {
      this.arquivoControl.push(this.fb.group({
        nomeArquivo: arq.nomeArquivo,
        conteudo: arq.conteudo
      }));
    });

    this.arquivoControl.markAsTouched();
    this.arquivoControl.updateValueAndValidity();
  }
}
